<template>
  <div class="personal_center">
    <div class="warp1200 fix">
      <PersonalCenterMenu
          :activeIndex="1"
      />
      <div class="f-fr center_right">
        <BookingList/>
        <PromoCruise/>
      </div>
    </div>
  </div>
</template>

<script>
const PersonalCenterMenu = () => import('@/components/User/PersonalCenterMenu')
const BookingList = () => import('@/components/Booking/BookingList/BookingList')
const PromoCruise = () => import('@/components/Cruise/PromoCruise')
export default {
  name: "BookingListPage",
  components: {
    PersonalCenterMenu,
    BookingList,
    PromoCruise,
  },

}
</script>

<style lang="less" scoped>
.personal_center {
  background: #f5f5f5;

  .center_right {
    width: 965px;
    padding-left: 20px;
  }
}
</style>
